<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <p style="display: none">{{ windowScrol }}</p>

    <div id="algolia-instant-search-demo">
      <div class="algolia-header mb-4">
        <div class="flex md:items-end items-center justify-between flex-wrap">
          <div id="parentx" style="z-index: 1">
            <vs-sidebar
              v-if="!isMobile() && subCategoriesControl == true"
              :reduce="reduce"
              :class="scrollviewSidebar"
              :reduce-not-hover-expand="notExpand2"
              static-position
              color="primary"
              class="sidebarx"
              spacer
              v-model="active2"
            >
              <div class="header-sidebar" slot="header">
                <h4>KATEGORİLER</h4>
              </div>
              <div :class="scrollviewMobil" v-scroll="handscroll">
                <vs-sidebar-item
                  index="tumu"
                  @click="
                    selectedCategory = 'Tümü';
                    productRefineDispatch('Tümü', 'top');
                  "
                >
                  Tümü
                </vs-sidebar-item>
                <vs-sidebar-group
                  open
                  :title="item.mainCategory"
                  v-for="(item, index) in categoryList"
                  :key="index"
                  @click="
                    selectedCategory = item;
                    listGorunumValidate == true
                      ? varyantliStokList(item)
                      : productRefineDispatch(item, 'top');
                  "
                >
                  <vs-sidebar-group
                    :title="item1.subCategories"
                    v-for="(item1, index1) in item.subCategory"
                    style="margin-left: 15px"
                    :key="index1"
                    @click="
                      selectedCategory = item1;
                      listGorunumValidate == true
                        ? varyantliStokList(item1)
                        : productRefineDispatch(item1, 'top');
                    "
                  >
                    <vs-sidebar-item
                      :index="item1.subCategory2 + index + index1 + index2"
                      v-for="(item2, index2) in item1.subCategory2"
                      @click="
                        selectedCategory = item2;
                        listGorunumValidate == true
                          ? varyantliStokList(item2)
                          : productRefineDispatch(item2, 'top');
                      "
                      :key="index2"
                    >
                      {{ item2.name }}
                    </vs-sidebar-item>
                  </vs-sidebar-group>
                </vs-sidebar-group>
              </div>
            </vs-sidebar>
            <vs-sidebar
              v-else-if="!isMobile() && subCategoriesControl == false"
              :reduce="reduce"
              :class="scrollviewSidebar"
              style="position: fixed"
              :reduce-not-hover-expand="notExpand2"
              color="primary"
              class="sidebarx"
              spacer
              v-model="active2"
            >
              <div class="header-sidebar" slot="header"></div>
              <div :class="scrollviewMobil" v-scroll="handscroll">
                <vs-sidebar-group open title="Kategoriler">
                  <vs-sidebar-item
                    :index="index"
                    v-for="(item, index) in categoryList"
                    :key="index"
                    @click="
                      selectedCategory = item;
                      listGorunumValidate == true
                        ? varyantliStokList(item)
                        : productRefineDispatch(item, 'top');
                    "
                  >
                    {{ item.name }}
                  </vs-sidebar-item>
                </vs-sidebar-group>
              </div>
            </vs-sidebar>
            <vs-sidebar
              v-else-if="isMobile() && subCategoriesControl == false"
              class="items-no-padding vs-sidebar-rounded background-absolute"
              parent="#algolia-content-container"
              :click-not-close="clickNotClose"
              :hidden-background="clickNotClose"
              v-model="isFilterSidebarActive"
            >
              <div class="p-6 filter-container">
                <h6 class="font-bold mb-4">Kategoriler</h6>
                <div v-if="subCategoriesControl == true">
                  <div :class="scrollviewMobil" v-scroll="handscroll">
                    <ul>
                      <vs-divider />

                      <li
                        style="margin-bottom: 5px"
                        v-for="(item, index) in categoryList"
                        :key="index"
                        @click="
                          selectedCategory = item;
                          productRefineDispatch(item, 'top');
                        "
                        class="flex items-center cursor-pointer py-1"
                      >
                        <feather-icon
                          style="margin-right: 5px"
                          icon="CircleIcon"
                          :svgClasses="[
                            { 'text-primary fill-current': item.isRefined },
                            'h-5 w-5',
                          ]"
                        />
                        <span :class="{ 'text-primary': item.isRefined }">{{
                          item.mainCategory
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else>
                  <div :class="scrollviewMobil" v-scroll="handscroll">
                    <ul>
                      <vs-divider />

                      <li
                        style="margin-bottom: 5px"
                        v-for="(item, index) in categoryList"
                        :key="index"
                        @click="
                          selectedCategory = item;
                          productRefineDispatch(item, 'top');
                        "
                        class="flex items-center cursor-pointer py-1"
                      >
                        <feather-icon
                          style="margin-right: 5px"
                          icon="CircleIcon"
                          :svgClasses="[
                            { 'text-primary fill-current': item.isRefined },
                            'h-5 w-5',
                          ]"
                        />
                        <span :class="{ 'text-primary': item.isRefined }">{{
                          item.name
                        }}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <vs-divider />
              </div>
            </vs-sidebar>
            <vs-sidebar
              v-else-if="isMobile() && subCategoriesControl == true"
              class="items-no-padding vs-sidebar-rounded background-absolute"
              parent="#algolia-content-container"
              :click-not-close="clickNotClose"
              :hidden-background="clickNotClose"
              v-model="isFilterSidebarActive"
            >
              <div class="p-6 filter-container">
                <div class="header-sidebar" slot="header">
                  <h4>KATEGORİLER</h4>
                </div>
                <div :class="scrollviewMobil" v-scroll="handscroll">
                  <vs-sidebar-item
                    index="tumu"
                    @click="
                      selectedCategory = 'Tümü';
                      productRefineDispatch('Tümü', 'top');
                    "
                  >
                    Tümü
                  </vs-sidebar-item>
                  <vs-sidebar-group
                    open
                    :title="item.mainCategory"
                    v-for="(item, index) in categoryList"
                    :key="index"
                    @click="
                      selectedCategory = item;
                      productRefineDispatch(item, 'top');
                    "
                  >
                    <vs-sidebar-group
                      :title="item1.subCategories"
                      v-for="(item1, index1) in item.subCategory"
                      style="margin-left: 15px"
                      :key="index1"
                      @click="
                        selectedCategory = item1;
                        productRefineDispatch(item1, 'top');
                      "
                    >
                      <vs-sidebar-item
                        :index="item1.subCategory2 + index + index1 + index2"
                        v-for="(item2, index2) in item1.subCategory2"
                        @click="
                          selectedCategory = item2;
                          productRefineDispatch(item2, 'top');
                        "
                        :key="index2"
                      >
                        {{ item2.name }}
                      </vs-sidebar-item>
                    </vs-sidebar-group>
                  </vs-sidebar-group>
                </div>

                <vs-divider />
              </div>
            </vs-sidebar>
          </div>
        </div>
      </div>
      <div
        id="algolia-content-container"
        class="relative clearfix"
        style="min-height: 1500px"
      >
        <!-- RIGHT COL -->
        <div :style="!isMobile() ? 'margin-left: calc(70px + 0.2rem);' : ''">
          <div style="margin-bottom: 8px" v-if="kdvInfo == true">
            <b-row align-h="center">
              <b-col>
                <vs-alert
                  style="width: auto; text-align: center; padding: 0px !important"
                  icon="warning"
                  active="true"
                  color="primary"
                >
                  <span
                    >Ürünlerin birim fiyatlarına kdv dahil
                    <strong>değildir!</strong>
                  </span>
                </vs-alert>
              </b-col>
            </b-row>
          </div>
          <!-- SEARCH BAR -->
          <vx-card>
            <div class="relative">
              <b-row style="align-items: center">
                <b-col cols="6" lg="6">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <feather-icon
                        class="md:inline-flex cursor-pointer"
                        icon="SearchIcon"
                        @click.stop="
                          listGorunumValidate == true
                            ? varyantliStokList()
                            : productRefineDispatch(selectedCategory, 'top')
                        "
                      />
                    </b-input-group-prepend>

                    <b-form-input
                      v-model="productAranan"
                      placeholder="Ürün ara..."
                      @keyup.enter="
                        listGorunumValidate == true
                          ? varyantliStokList()
                          : productRefineDispatch(selectedCategory, 'top')
                      "
                      @input="degerSifirla()"
                    />
                  </b-input-group>
                </b-col>
                <b-col lg="1" sm="12" v-if="!isMobile() && ROL == 'ADMIN'">
                  <ExcelYazdirComponent :excelData="productList" />
                </b-col>
                <b-col lg="1" sm="12" v-if="!isMobile() && ROL == 'ADMIN'">
                  <vs-button
                    style="border-radius: 5px"
                    variant="primary"
                    @click="xmlToJson"
                  >
                    XML
                  </vs-button>
                </b-col>
                <b-col cols="2" lg="2" md="3" sm="3" v-else>
                  <b-row>
                    <div>
                      <feather-icon
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer inline-flex lg:hidden cursor-pointer mr-4"
                        icon="FilterIcon"
                        @click.stop="toggleFilterSidebar"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col
                  cols="4"
                  lg="4"
                  md="3"
                  sm="3"
                  style="text-align: end"
                  v-if="!isMobile()"
                >
                  <b-row>
                    <div>
                      <feather-icon
                        icon="ListIcon"
                        @click="listeGorunum"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current':
                            currentItemView == 'lg:w-1/4 md:w-1/3 sm:w-1/2 xs:w-1/2',
                        }"
                      />

                      <feather-icon
                        icon="GridIcon"
                        @click="
                          productRefineDispatch(selectedCategory, 'top');
                          currentItemView = 'lg:w-1/4 md:w-1/3 sm:w-1/2 xs:w-1/2';
                          listGorunumValidate = false;
                        "
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current':
                            currentItemView == 'lg:w-1/4 md:w-1/3 sm:w-1/2 xs:w-1/2',
                        }"
                      />
                      <feather-icon
                        icon="ColumnsIcon"
                        @click="
                          productRefineDispatch(selectedCategory, 'top');
                          currentItemView = 'lg:w-1/3 md:w-1/3 sm:w-1/2 xs:w-1/2';
                          listGorunumValidate = false;
                        "
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current':
                            currentItemView == 'lg:w-1/3 md:w-1/3 sm:w-1/2 xs:w-1/2',
                        }"
                      />
                    </div>
                  </b-row>
                </b-col>
                <b-col cols="4" lg="4" md="3" sm="3" style="text-align: end" v-else>
                  <b-row>
                    <div>
                      <feather-icon
                        icon="ListIcon"
                        @click="mobileItemGrid = '12'"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current': mobileItemGrid == '12',
                        }"
                      />
                      <feather-icon
                        icon="GridIcon"
                        @click="mobileItemGrid = '6'"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current': mobileItemGrid == '6',
                        }"
                      />
                      <feather-icon
                        icon="ColumnsIcon"
                        @click="mobileItemGrid = '12'"
                        class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                        :svgClasses="{
                          'text-primary stroke-current': mobileItemGrid == '12',
                        }"
                      />
                    </div>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </vx-card>
          <div class="relative mb-8"></div>
          <div v-if="listGorunumValidate == false">
            <div>
              <template v-if="'item-grid-view'">
                <div class="items-grid-view vx-row match-height" v-if="!isMobile()">
                  <div
                    :class="currentItemView"
                    class="vx-col w-full mb-base"
                    v-for="(item, index) in productList"
                    :key="index"
                  >
                    <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <div class="flex flex-wrap" v-if="isAuth">
                          <!-- PRIMARY BUTTON: ADD TO WISH LIST -->

                          <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)"
                            v-if="varyantlimi == 'true'"
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span class="text-sm font-semibold ml-2">SEPETE EKLE</span>
                          </div>

                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)"
                            v-else
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity != 0 && isInCart(item.barcode)"
                              >GÖRÜNTÜLE</span
                            >
                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity > 0 && !isInCart(item.barcode)"
                              >SEPETE EKLE</span
                            >

                            <span
                              style="pointer-events: none"
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity <= 0"
                              >TÜKENDİ</span
                            >
                          </div>
                        </div>
                        <div class="flex flex-wrap" v-else>
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToDetail(item)"
                            v-if="varyantlimi == 'true'"
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span class="text-sm font-semibold ml-2"
                              >Detay Görüntüle</span
                            >
                          </div>
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToDetail(item)"
                            v-else
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity > 0"
                              >Detay Görüntüle</span
                            >

                            <span
                              style="pointer-events: none"
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity <= 0"
                              >TÜKENDİ</span
                            >
                          </div>
                        </div>
                      </template>
                    </item-grid-view>
                  </div>
                </div>
                <b-row class="items-grid-view match-height" align-v="stretch" v-else>
                  <b-col
                    align-self="stretch"
                    :cols="mobileItemGrid"
                    v-for="(item, index) in productList"
                    :key="index"
                  >
                    <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <div class="flex flex-wrap" v-if="isAuth">
                          <!-- PRIMARY BUTTON: ADD TO WISH LIST -->

                          <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)"
                            v-if="varyantlimi == 'true'"
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                            <span class="text-sm font-semibold ml-2">SEPETE EKLE</span>
                          </div>
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)"
                            v-else
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity != 0 && isInCart(item.barcode)"
                              >GÖRÜNTÜLE</span
                            >
                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity > 0 && !isInCart(item.barcode)"
                              >SEPETE EKLE</span
                            >
                            <span
                              style="pointer-events: none"
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity <= 0"
                              >TÜKENDİ</span
                            >
                          </div>
                        </div>
                        <div class="flex flex-wrap" v-else>
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToDetail(item)"
                            v-if="varyantlimi == 'true'"
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                            <span class="text-sm font-semibold ml-2"
                              >Detay Görüntüle</span
                            >
                          </div>
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="goToDetail(item)"
                            v-else
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                            <span
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity > 0"
                              >Detay Görüntüle</span
                            >
                            <span
                              style="pointer-events: none"
                              class="text-sm font-semibold ml-2"
                              v-if="item.quantity <= 0"
                              >TÜKENDİ</span
                            >
                          </div>
                        </div>
                      </template>
                    </item-grid-view>
                  </b-col>
                </b-row>
              </template>
            </div>
          </div>

          <div v-if="listGorunumValidate == false">
            <vs-card>
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Gösterilen kayıt </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['50', '100', '250', '500', '1000']"
                    class="mx-1"
                    v-on:change="productRefineDispatch(selectedCategory, 'top')"
                  />
                </div>
                <div>
                  <b-pagination
                    pills
                    :total-rows="KAYITSAYISI"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    v-model="currentGelenPage"
                    @input="productRefineDispatch(selectedCategory, 'top')"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </vs-card>
          </div>
          <div v-else>
            <div>
              <template>
                <div>
                  <ag-grid-vue
                    style="width: 100%; height: 750px"
                    class="ag-theme-alpine"
                    :animateRows="true"
                    :suppressCopyRowsToClipboard="true"
                    :defaultColDef="defaultColDef"
                    :columnDefs="productListColumn"
                    :rowData="productListVaryant"
                    :localeText="localeText"
                    :pagination="true"
                    :rowSelection="rowSelection"
                    @grid-ready="onGridReady"
                  >
                  </ag-grid-vue>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal-resim"
      id="modal-primary"
      modal-class="modal-primary"
      size="sm"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <img :src="imageLink" style="width: 100%" @error="errorImage" />
    </b-modal>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import userJson from "../../../public/user.json";
import { isMobile } from "mobile-device-detect";
import Store from "../../store/store";
import state from "../../store/state";
import ExcelYazdirComponent from "../components/b2b-components/ExcelYazdirComponent.vue";
import ProductListStokResim from "./CellRenderer/ProductListStokResim.vue";
import TextGorunumCellRenderer from "./CellRenderer/TextGorunumCellRenderer";
import MalKabulDetayOlculenDeger from "./CellRenderer/MalKabulDetayOlculenDeger.vue";
import { xml2json, json2xml } from "xml-js";
import {
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormGroup,
  BFormTextarea,
} from "bootstrap-vue";
export default {
  components: {
    json2xml,
    xml2json,
    MalKabulDetayOlculenDeger,
    TextGorunumCellRenderer,
    ProductListStokResim,
    AgGridVue,
    BPagination,
    ExcelYazdirComponent,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormGroup,
    BFormTextarea,
    ItemGridView: () =>
      import("../components/b2b-components/products-components/ItemGridView.vue"),
    ItemListView: () =>
      import("../components/b2b-components/products-components/ItemListView.vue"),
  },
  data() {
    return {
      sorterStockList: [],
      ROL: "",
      selectedCategory: "",
      sidebarFixed: false,
      isAuth: Store.state.tokenId,
      active2: true,
      musteriTanim: userJson.musteriTanim,
      notExpand2: false,

      notExpand: true,
      reduce: true,
      active: false,
      productListColumn: [],
      rowSelection: null,
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      imageLink: "",
      sistemurl: "",
      mobileItemGrid: "6",
      varyantlimi: userJson.varyant,
      kdvInfo: userJson.kdvInfo,
      subCategoriesControl: userJson.subCategories,
      scrollview: "",
      scrollviewMobil: "",
      scrollviewSidebar: "scroll-hand-sidebar",
      margintop: "",
      KAYITSAYISI: 0,
      pageLength: 50,
      kategorideger: "",
      currentGelenPage: 1,

      arananKayitSayisi: 0,
      currentPage: 1,
      perPage: 1,
      siparisExcelData: [],
      productAranan: "",
      list: [],
      categoryList: [],
      productList: [],
      productListVaryant: [],
      allProductList: [],
      isFilterSidebarActive: false,
      clickNotClose: false,
      currentItemView: "lg:w-1/4 md:w-1/3 sm:w-1/2 xs:w-1/2",
      item_grid: "lg:w-1/4 md:w-1/3 sm:w-1/2 xs:w-1/2",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 150,
        wheelSpeed: 0.6,
      },
      listGorunumValidate: false,

      dir: false,
      secilenStok: [],
      secilenAdetDegeri: "",
    };
  },
  computed: {
    customerId: {
      get() {
        return this.$store.state.UserId;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    tokenIdLocal: {
      get() {
        return this.$store.state.tokenId;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    sepet: {
      get() {
        return this.$store.state.eCommerce.cartItems;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stocks: {
      get() {
        return this.$store.state.eCommerce.StockList;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stocksVaryant: {
      get() {
        return this.$store.state.eCommerce.StockListVaryant;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    categories: {
      get() {
        return this.$store.state.eCommerce.CategoryList;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    userPriceType: {
      get() {
        return this.$store.state.userPriceType;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    toValue() {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max,
      ];
    },
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    windowScrol() {
      var documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );

      var windowHeight = window.innerHeight;
      if (this.$store.state.scrollY > 100) {
        document.documentElement.style.setProperty("--main-top-margin", "65px");
        this.margintop = "margintop";
        this.scrollview = "scroll-hand2";
        this.scrollviewMobil = "scroll-hand2-mobil";
      } else {
        document.documentElement.style.setProperty("--main-top-margin", "190px");
        this.margintop = "";
        this.scrollview = "scroll-hand";
        this.scrollviewMobil = "scroll-hand-mobil";
      }
      if (
        parseInt(this.$store.state.scrollY) + parseInt(windowHeight) >=
        parseInt(documentHeight) - 350
      ) {
        this.scrollviewSidebar = "scroll-hand-sidebar";
      } else {
        this.scrollviewSidebar = "scroll-hand-sidebar2";
      }
      return this.$store.state.scrollY;
    },
  },
  watch: {
    userPriceType(val) {
      return val;
    },
    customerId(val) {
      return val;
    },
    tokenIdLocal(val) {
      return val;
    },
    stocks(val) {
      this.productRefine();
      return val;
    },
    stocksVaryant() {
      this.varyantliStokList();
    },
    categories() {
      this.getProductCategory();
    },
    windowWidth() {
      this.setSidebarWidth();
    },
  },
  methods: {
    getTableSort() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        module: "stockList",
        isDue: "listForModule"
      };
      soap.createClient(url, function (err, client) {
        client.B2B_TABLES_SORT(args, function (err, result) {
          vm.veriler = JSON.parse(result.B2B_TABLES_SORTResult); 
          vm.sorterStockList = vm.veriler;
        });
      });
    },
    xmlToJson() {
      let xmlData = "";
      if (this.listGorunumValidate == true) xmlData = this.stocksVaryant;
      else xmlData = this.productList;
      try {
        // JSON verisini XML'e çevir
        const xml = json2xml(
          { products: xmlData },
          { compact: true, ignoreComment: true, spaces: 4 }
        );

        // XML verisini bir Blob nesnesine dönüştür
        const blob = new Blob([xml], { type: "application/xml" });

        // Blob nesnesini indirilebilir bir bağlantıya dönüştür
        const url = URL.createObjectURL(blob);

        // Geçici bir bağlantı elementi oluştur
        const link = document.createElement("a");
        link.href = url;
        link.download = "data.xml"; // İndirme dosyasının adı

        // Bağlantıyı tıklayarak dosyanın indirilmesini sağla
        link.click();

        // Belleği serbest bırak
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("XML oluşturma hatası:", error);
      }
    },
    errorImage(e) {
      if (e.type == "error")
        e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
    },
    sepetListGet() {},
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },

    varyantliStokListDispatch() {
      let args = {
        ARANAN: "",
        ACTID: this.customerId,
        userPriceType: this.userPriceType,
        priceType: userJson.priceType,
      };
      this.$store.dispatch("getDataStockVaryant", args).then((response) => {
        if (response == "-1") {
        } else {
        }
      });
    },
    generateColumnDefs(rowData, columnDefs) {
      // İlk veri satırını kontrol ederek boş sütunları belirle
      if (rowData.length > 0) {
        this.productListColumn = this.sorterStockList
          .map((item) => item.Item1)
          .map((key) => {
            const isEmpty = rowData.every(
              (row) =>
                row[key] === "" ||
                row[key] === 0 ||
                row[key] == null ||
                key == "barcode" ||
                key == "KAYITSAYISI" ||
                key == "images" ||
                key == "page" ||
                key == "stockCode" ||
                key == "count" ||
                key == "image" ||
                key == "unit"
            );

            return isEmpty
              ? null
              : {
                  headerName: this.$t(key),
                  field: key,
                  filter: "agSetColumnFilter",
                  wrapText: true,
                  autoHeight: true,
                  cellRenderer: "TextGorunumCellRenderer",
                };
          })
          .filter((colDef) => colDef !== null);
      }
    },
    varyantliStokList(val) {
      try {
        this.scrollToTopP();
        var vm = this;
        vm.productListVaryant = vm.stocksVaryant;

        if (typeof val == "undefined") {
          vm.kategorideger == "";
        } else if (val != "" && val.name != "Tümü") {
          /*	if (val.name != vm.kategorideger) {
						this.pageLength = 50;
						this.currentGelenPage = 1;
					}*/
          vm.kategorideger = val.name;
          vm.categoryList.forEach((val, index) => {
            if (vm.categoryList[index].isRefined == true) {
              vm.categoryList[index].isRefined = false;
            }
          });
          vm.productListVaryant = vm.productListVaryant.filter((post) => {
            return post.category.toUpperCase().includes(vm.kategorideger.toUpperCase());
          });
          val.isRefined = true;
        } else vm.productListVaryant = vm.stocksVaryant;
        if (vm.productAranan != "" && vm.productAranan != "Tümü") {
          vm.productListVaryant = vm.productListVaryant.filter((post) => {
            return (
              post.stockCode.toUpperCase().includes(vm.productAranan.toUpperCase()) ||
              post.stockName.toUpperCase().includes(vm.productAranan.toUpperCase()) ||
              post.barcode.toUpperCase().includes(vm.productAranan.toUpperCase())
            );
          });
        } else vm.productListVaryant = vm.productListVaryant;

        let columnList = vm.sorterStockList.map((item) => item.Item1); 
        vm.productListColumn = [];
        vm.generateColumnDefs(vm.productListVaryant);
        vm.productListColumn.push({
          sortable: true,
          pinned: "left",
          filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
          cellRenderer: "MalKabulDetayOlculenDeger",
          filter: "agSetColumnFilter",
        });
        columnList.forEach((val, index) => {
          if (val == "image") {
            vm.productListColumn.push({
              width: 120,
              headerName: vm.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              wrapText: true,
              autoHeight: true,
              cellClass: "textType",
              cellRenderer: "ProductListStokResim",
              pinned: "left",
            });
          } else if (val == "barcode") {
            if (vm.varyantlimi == "true")
              vm.productListColumn.push({
                headerName: vm.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                wrapText: true,
                autoHeight: true,
                cellClass: "textType",
                cellRenderer: "TextGorunumCellRenderer",
                pinned: "left",
              });
          } else if (val == "stockCode") {
            vm.productListColumn.push({
              headerName: vm.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              wrapText: true,
              autoHeight: true,
              cellClass: "textType",
              cellRenderer: "TextGorunumCellRenderer",
              pinned: "left",
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    onClick(event) {
      // alert("lalalala"+event)
      this.imageLink = this.sistemurl + event;
      this.$refs["modal-resim"].show();
    },
    selectionChanged(params) {
      this.secilenStok = params.selectedRows;
    },
    listeGorunum() {
      this.scrollToTopP();
      this.listGorunumValidate = true;
      this.varyantliStokListDispatch();
    },
    isMobile: function () {
      return isMobile;
    },
    handscroll(el) {},

    degerSifirla() {
      this.pageLength = 50;
      this.currentGelenPage = 1;
    },

    scrollToTopP() {
      window.scrollTo(0, 0);
      this.$store.commit("eCommerce/UPDATE_WINDOW_SCROLL_PRODUCT_Y", window.scrollY);
      localStorage.setItem("UPDATE_WINDOW_SCROLL_PRODUCT_Y", window.scrollY);
    },
    scrollToTop() {
      window.scrollTo(0, Store.state.eCommerce.productScrollY);
    },

    productRefineDispatch(val, scroll) {
      let args = {
        token: state.tokenId,
        KATEGORI: val.name,
        ARANAN: this.productAranan,
        ILKKAYIT: (this.currentGelenPage - 1) * this.pageLength,
        SONKAYIT: this.pageLength,
        EKSORGU: "",
        ACTID: "",
      };
      this.$store.dispatch("getDataStock", args).then((response) => {
        if (response == "-1") {
        } else {
        }
      });
    },
    // filter by product
    productRefine(val, scroll) {
      var vm = this;
      vm.productList = [];

      vm.veriler = vm.stocks;

      vm.productList = vm.veriler;

      if (vm.stocks.length > 0) {
        // this.$store.commit("eCommerce/CATEGORY_VALUE", val);
        vm.productAranan = "";

        if (val == "Tümü") {
          vm.kategorideger = "Tümü";
        } else {
          if (typeof val == "undefined") {
            vm.kategorideger == "";
          } else if (val != "") {
            /*	if (val.name != vm.kategorideger) {
								this.pageLength = 50;
								this.currentGelenPage = 1;
							}*/
            vm.kategorideger = val.name;

            vm.categoryList.forEach((val, index) => {
              if (vm.categoryList[index].isRefined == true) {
                vm.categoryList[index].isRefined = false;
              }
            });
            vm.productList = [];
            vm.productList = vm.stocks.filter((post) => {
              return post.kategoriKodu
                .toUpperCase()
                .includes(vm.kategorideger.toUpperCase());
            });
            val.isRefined = true;
          }
        }
        if (vm.veriler != "") vm.KAYITSAYISI = vm.productList[0].KAYITSAYISI;
        //	vm.productList = vm.productList.slice((this.currentGelenPage - 1) * this.pageLength, this.currentGelenPage * this.pageLength)

        //	localStorage.setItem("pageLength", this.pageLength);
        //	localStorage.setItem("sonKayit", this.currentGelenPage);
        if (scroll == "top") {
          vm.scrollToTopP();
        } else {
          vm.scrollToTop();
        }
      }
    },

    //category list
    getProductCategory() {
      var vm = this;
      vm.list = vm.categories;
      vm.notExpand = false;
      if (vm.categories.length > 0) {
        let s = [];
        if (vm.subCategoriesControl != true) {
          vm.categoryList.push({
            name: "Tümü",
            isRefined: false,
          });
          vm.list.forEach((value, index) => {
            vm.categoryList.push({
              name: vm.list[index].kategoriKodu,
              isRefined: false,
            });
          });
        } else {
          var parseString = vm.StringToXML(vm.list[0].Categories);
          let deger = [];
          let array = [];
          let olusturulan = {};
          deger = vm.xml2json(parseString);

          s = deger.Category.Categories;

          if (typeof s.length == "undefined") {
            s = [{ program: s.program, satisDurum: s.satisDurum }];
          }
          if (typeof s != "undefined")
            try {
              s.forEach((val, index) => {
                vm.categoryList.push({
                  mainCategory: val.SPECCODE3,
                  subCategory: [],
                });
                if (typeof val.AltCategories.length == "undefined") {
                  vm.categoryList[index].subCategory.push({
                    subCategories: val.AltCategories.SPECCODE4,
                    subCategory2: [],
                  });
                  if (typeof val.AltCategories.AltAltCategories[0] == "undefined") {
                    vm.categoryList[index].subCategory[index].subCategory2.push({
                      name: val.AltCategories.AltAltCategories.SPECCODE5,
                      isRefined: false,
                    });
                  } else
                    val.AltCategories.AltAltCategories.forEach((val2, index2) => {
                      vm.categoryList[index].subCategory[index2].subCategory2.push({
                        name: val2.SPECCODE5,
                        isRefined: false,
                      });
                    });
                } else
                  val.AltCategories.forEach((val1, index1) => {
                    vm.categoryList[index].subCategory.push({
                      subCategories: val1.SPECCODE4,
                      subCategory2: [],
                    });
                    if (typeof val1.AltAltCategories[0] == "undefined") {
                      vm.categoryList[index].subCategory[index1].subCategory2.push({
                        name: val1.AltAltCategories.SPECCODE5,
                        isRefined: false,
                      });
                    } else
                      val1.AltAltCategories.forEach((val2, index2) => {
                        vm.categoryList[index].subCategory[index1].subCategory2.push({
                          name: val2.SPECCODE5,
                          isRefined: false,
                        });
                      });
                  });
              });
            } catch (error) {
              console.log(error);
            }
        }
      }
    },
    StringToXML(oString) {
      //code for IE
      if (window.ActiveXObject) {
        var oXML = new ActiveXObject("Microsoft.XMLDOM");
        oXML.loadXML(oString);
        return oXML;
      }
      // code for Chrome, Safari, Firefox, Opera, etc.
      else {
        return new DOMParser().parseFromString(oString, "text/xml");
      }
    },
    xml2json(xml) {
      try {
        var obj = {};

        if (xml.children.length > 0) {
          for (var i = 0; i < xml.children.length; i++) {
            var item = xml.children.item(i);
            var nodeName = item.nodeName;

            if (typeof obj[nodeName] == "undefined") {
              obj[nodeName] = this.xml2json(item);
            } else {
              if (typeof obj[nodeName].push == "undefined") {
                var old = obj[nodeName];

                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(this.xml2json(item));
            }
          }
        } else {
          obj = xml.textContent;
        }
        return obj;
      } catch (e) {
        console.log(e.message);
      }
    },

    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false;
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true;
      }
    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return;
      this.isFilterSidebarActive = !this.isFilterSidebarActive;
    },

    additemInCart(item) { 
      var vm = this;
      const vs = this.$vs;
      var sepetek = [];
      sepetek.push({
        quantity: 1,
        stockQuantity: item.quantity,
        renkAciklamasi: item.colorName,
        bedenAdi: item.size,
        fiyat: typeof item.fiyat == "undefined" ? item.price : item.fiyat,
        barcode: item.barcode,
        productCode: item.stockCode,
        ONAY: item.ONAY,
        productName: item.stockName,
        kdv: item.vat,
        price: typeof item.fiyat == "undefined" ? item.price : item.fiyat,
        customerCode: this.$store.state.UserId,
        unit: parseFloat(item.unit) == 0 ? 1 : item.unit,
        image: item.image, 
        customerName: this.$store.state.B2BfirmaAdi,

      }); 
      console.log(sepetek)
      vm.$store.dispatch("eCommerce/additemInCartToplu", sepetek[0]).then((response) => {
        if (response == "ok") {
        } else
          vs.notify({
            text: "Ürün onay bekleyenlerde olabilir",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-center",
          });
      });
    },

    goToDetail(item) {
      this.$router
        .push({
          name: "ecommerce-item-detail-view",
          params: { item_id: item.stockCode },
        })
        .catch(() => {});
    },
    cartButtonClicked(item) {
      if (this.varyantlimi == "true") {
        this.$router
          .push({
            name: "ecommerce-item-detail-view",
            params: { item_id: item.stockCode },
          })
          .catch(() => {});
      } else {
        /*
				if (item.quantity == 0) {
					const vs = this.$vs;
					vs.notify({
						text: "ürün stokta bulunmamaktadır",
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center",
					});
				} else {*/

        this.isInCart(item.barcode)
          ? this.$router.push("/products/checkout").catch(() => {})
          : this.additemInCart(item);
        //   }
      }
    },
    getProductData() {
      const data = [];
      this.$store.dispatch("getDataCategory").then((response) => {
        if (response == "-1") {
          data["isCurrActive"] = false;
        } else {
          data["isCurrActive"] = true;
        }
      });
      let args = {
        token: state.tokenId,
        KATEGORI: "",
        ARANAN: "",
        ILKKAYIT: (this.currentGelenPage - 1) * this.pageLength,
        SONKAYIT: this.pageLength,
        EKSORGU: "",
        ACTID: this.customerId,
        userPriceType: this.userPriceType,
        priceType: userJson.priceType,
      };

      this.$store.dispatch("getDataStock", args).then((response) => {
        if (response == "-1") {
        } else {
        }
      });
      //	this.$store.commit("setToken", data);
    },
  },
  created() {
    this.getTableSort();
    this.getProductData();
    this.ROL = Store.state.ROL;
    if (userJson.startView == "list") {
      this.listGorunumValidate = true;
      this.listeGorunum();
    } else {
      this.listGorunumValidate = false;
    }

    this.rowSelection = "single";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.sistemurl = userJson.resimUrl;
    this.scrollview = "scroll-hand";
    this.scrollviewMobil = "scroll-hand-mobil";
    document.documentElement.style.setProperty("--main-bg-color", userJson.themeColor);
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "ecommerce-item-detail-view") {
      this.$store.commit("eCommerce/UPDATE_WINDOW_SCROLL_PRODUCT_Y", window.scrollY);
      localStorage.setItem("UPDATE_WINDOW_SCROLL_PRODUCT_Y", window.scrollY);
    } else {
      this.$store.commit("eCommerce/UPDATE_WINDOW_SCROLL_PRODUCT_Y", 0);
      localStorage.setItem("UPDATE_WINDOW_SCROLL_PRODUCT_Y", 0);
    }
    /*   */
    next();
  },
};
</script>

<style lang="scss">
[dir] .vs-sidebar--background {
  background: none !important;
  display: none !important;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

table.vgt-table {
  font-size: small;
}

[dir="ltr"] #algolia-instant-search-demo #algolia-content-container .vs-sidebar {
  height: auto !important;
}

.margintop {
  top: calc(360px) !important;
}

:root {
  /* default value */
  --main-bg-color: brown;
  --main-top-margin: 190px;
}

.vs-sidebar.vs-sidebar-reduce {
  position: fixed !important;
  margin-left: 35px;
  margin-top: var(--main-top-margin);
}

.scroll-hand-sidebar {
  display: none;
}

.scroll-hand-sidebar2 {
  display: inline;
}

.scroll-hand-mobil {
  max-height: 450px;
  overflow-y: auto;
}

.scroll-hand2-mobil {
  max-height: 400px;
  overflow-y: auto;
}

.scroll-hand {
  max-height: 300px;
  overflow-y: auto;
}

.scroll-hand2 {
  max-height: 400px;
  overflow-y: auto;
}

.scroll-area {
  position: relative;
  margin: auto;
  width: 400px;
  height: 300px;
}

[dir] .page-item.active .page-link {
  background-color: var(--main-bg-color);
  border-color: var(--main-bg-color);
}

.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  height: 100%;
}

#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {
    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: 0.5rem;
    }

    .vs-sidebar--items {
      border-radius: 0.5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

[dir="ltr"] .vs-sidebar.vs-sidebar-reduce {
  max-height: 520px !important;
}
</style>
